/**
 * @author Owais Liaquat Ali
 * @datetime May, 29th 2023
 * @description: This class is for date time parsed.
 */
import { Pipe, PipeTransform } from '@angular/core';
import {
  convertParseDateTime,
  extractDateTimeFromDateStringLangSpecific,
  convertParseDateTimeLangSpecific
} from 'src/app/shared/utils/utility.service';
import { StateManagementService } from '../../../../shared/services/state-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { enUS, fr } from 'date-fns/locale';
import { format, parse } from 'date-fns';

@Pipe({
  name: 'parsedDateTime',
})
export class ParsedDateTimePipe implements PipeTransform {
  constructor(private stateManagementService: StateManagementService) {}
  transform(
    date: string,
    parseFormat:
      | 'hh:mm a'
      | 'HH:mm'
      | 'yyyy-MM-dd'
      | 'yyyy/MM/dd'
      | 'dd/MM/yyyy'
      | 'MM/dd/yyyy'
      | "EEE, MMM do, yyyy 'at' h:mm a"
      | 'yyyy, MM, dd h:mm a'
      | 't'
      | 'yyyy/MM/dd hh:mm a'
      | 'MMM d, yyyy h:mma'
      | 'EEEE',
    currentFormat:
      | 'hh:mm a'
      | 'hh:mma'
      | 'HH:mm'
      | 'yyyy-MM-dd'
      | 'yyyy/MM/dd'
      | "EEE, MMM do, yyyy 'at' h:mm a"
      | "EEE, MMM d, yyyy 'at' h:mm a"
      | 'yyyy, MM, dd h:mm a'
      | 't'
      | `yyyy/MM/dd hh:mm a`
      | `yyyy, MM, dd hh:mm a`
      | `yyyy-MM-dd'T'HH:mm:ss`
      | `MM/dd/yyyy, h:mm:ss a`
      | 'MM/dd/yyyy'
      | 'EEEE' = "yyyy-MM-dd'T'HH:mm:ss"
  ): any {
    if (!date) return null;
    const language = this.stateManagementService.getUserLanguage();
    if(currentFormat === "EEEE") {
      if(language == LANG_CONST.FRENCH){
        return convertParseDateTimeLangSpecific(
            String(date),
            "EEEE",
            parseFormat,
            fr
          );
      }
      else {
        return convertParseDateTimeLangSpecific(
            String(date),
            "EEEE",
            parseFormat,
            enUS
          );
      }
    }
    else {
      if(language == LANG_CONST.FRENCH){
        return convertParseDateTimeLangSpecific(
          extractDateTimeFromDateStringLangSpecific(String(date), currentFormat),
          "yyyy-MM-dd'T'HH:mm:ss",
          parseFormat,
          fr
        );
      }
      else {
        return convertParseDateTimeLangSpecific(
          extractDateTimeFromDateStringLangSpecific(String(date), currentFormat),
          "yyyy-MM-dd'T'HH:mm:ss",
          parseFormat,
          enUS
        );
      }
    }
  }
}
